// Fonction pour animer les lettres en JavaScript pur
function animateText(id, delay, offset, scint, finalOpacity = 1, byWord = false) {
  let textElement = document.getElementById(id);
  let text = textElement.innerText;
  let elements = []; // On utilisera cet array pour les lettres ou les mots
  textElement.style.opacity = 1;  // Initialement rendre visible

  let linkHref = textElement.getAttribute('href'); // On regarde si un href existe

  // Créer un tableau de lettres ou de mots et les ajouter à l'élément
  textElement.innerHTML = '';  // Vider le contenu du texte original

  // Découpe en mots si `byWord` est true, sinon par lettres
  let parts = byWord ? text.split(' ') : text.split('');
  
  parts.forEach(part => {
    // Si la partie est un saut de ligne (présence d'un <br>), on le garde
    if (part === '\n') {
      let br = document.createElement('br');
      textElement.appendChild(br);
      return;
    }

    let span = document.createElement('span');
    span.innerText = part;
    span.style.opacity = 0;  // Initialiser comme invisible
    span.style.position = 'relative';
    span.style.left = '10px';  // Position initiale
    span.style.transition = 'opacity 0.5s ease, left 0.5s ease';  // Transitions pour l'animation
    span.style.color = 'rgba(255, 255, 255, 0)';

    // Ajouter l'attribut href si disponible
    if (linkHref) {
      span.style.cursor = 'pointer';  // Apparence d'un lien
      span.onclick = () => { window.open(linkHref, '_blank'); }; // Redirection au clic
    }

    elements.push(span);
    textElement.appendChild(span);  // Ajouter la partie (lettre ou mot)

    
    if (/\d/.test(part)) {
      span.classList.add('nbr');
    }

    
    // Ajouter un espace entre les mots (si c'est un mot)
    if (byWord && part !== ' ') {
      let space = document.createElement('span');
      space.innerText = ' ';
      textElement.appendChild(space);
    }
  });

  // Animation des lettres ou mots
  setTimeout(() => {
    elements.forEach((element, index) => {
      setTimeout(() => {
        element.style.color = 'rgba(232, 217, 251, ' + finalOpacity + ')';
        element.style.opacity = 1;  // Rendre visible
        element.style.left = '0';  // Réinitialiser la position
      }, index * delay);  // Délai entre chaque élément
    });
  }, 200 + offset);  // Délai avant de commencer l'animation

  // Effet de clignotement doux si 'scint' est vrai
  if (scint) {
    setTimeout(() => {
      let fadeInOut = () => {
        textElement.style.transition = 'opacity 1s ease-in-out';
        textElement.style.opacity = textElement.style.opacity == 1 ? 0.2 : 1;
      };
      setInterval(fadeInOut, 1000);  // Alterner opacité toutes les 2 secondes
    }, 200 + text.length * delay);
  }

  // Ajouter un effet de hover sur les liens, si le href est trouvé
  if (linkHref) {
    elements.forEach(element => {
      element.style.transition = 'opacity 0.2s ease';  // Transition douce pour le hover
      element.addEventListener('mouseenter', () => {
        element.style.opacity = 0.7;  // Réduire l'opacité sur hover
      });
      element.addEventListener('mouseleave', () => {
        element.style.opacity = 1;  // Rétablir l'opacité après hover
      });
    });
  }
}




function animateJumpingLetters(id, delay, delay2, jumpHeight, reverse) {
  let textElement = document.getElementById(id);
  let letters = textElement.querySelectorAll('span'); 
  if (!reverse) {
    letters.forEach((letter, index) => {
      
      setTimeout(() => {
        // Appliquer l'animation pour faire sauter la lettre
        letter.style.transition = 'bottom 0.3s ease';  // Animation de la position verticale
        letter.style.position = 'relative';  // Assurez-vous que la lettre soit en position relative
        letter.style.bottom = `${jumpHeight}px`;  // Faire sauter la lettre d'une hauteur spécifiée
        
        setTimeout(() => {
          // Revenir à la position initiale après le saut
          letter.style.bottom = '0px';
        }, delay2);  // Retourner après un délai de 300ms
      }, index * delay);  // Délai entre chaque lettre
    });
  }else{
    // Boucle pour appliquer l'animation de saut à chaque lettre
    letters.forEach((letter, index) => {
      setTimeout(() => {
        // Appliquer l'animation pour faire sauter la lettre
        letter.style.transition = 'bottom 0.3s ease';  // Animation de la position verticale
        letter.style.position = 'relative';  // Assurez-vous que la lettre soit en position relative
        letter.style.bottom = `${jumpHeight}px`;  // Faire sauter la lettre d'une hauteur spécifiée

        setTimeout(() => {
          // Revenir à la position initiale après le saut
          letter.style.bottom = '0px';
        }, delay2);  // Retourner après un délai de 300ms
      }, ((letters.length - 1)* delay) - index * delay);  // Délai entre chaque lettre
    });
  }
}



// Lancer l'animation pour chaque élément
  // Le texte 'clic' scintille indéfiniment

window.animateText = animateText;
window.animateJumpingLetters = animateJumpingLetters;




